import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-white md:ml-auto md:max-w-[531px] xl:max-w-[830px]',
    text: 'heading-m',
    searchInput: '',
    searchIcon: '',
    searchEndAdornment: '',
    searchCloseButton: 'h-6 w-6',
    searchCloseIcon: '',
    option: 'heading-s'
  },
  variants: {
    highlight: {
      true: {
        text: 'text-accent'
      }
    },
    focused: {
      true: {},
      false: {}
    }
  }
});
